import React from 'react';
import { HbrOption, HbrSelect } from '@harbor/elements-react-standalone';
import type { AttainmentPeriodMeta } from '../../../hooks/attainment-hooks';
import { formatPeriodRange } from '../../../support/attainmentLeader';
import { asSingleValue } from '../../../support/utils';
import { DASH } from '../Campaigns/CampaignChartCard';

interface Props {
  intervals: AttainmentPeriodMeta[];
  /** The interval the figures below refer to. */
  selected: AttainmentPeriodMeta | null;
  /** The date-based current interval — flagged "(current)" in the list. */
  current: AttainmentPeriodMeta | null;
  onChange: (label: string) => void;
}

const optionText = (p: AttainmentPeriodMeta, current: AttainmentPeriodMeta | null) =>
  `${p.label || p.interval || p.sheet_id}${current && p.label === current.label ? ' (current)' : ''}`;

/** Names the goaling interval every figure refers to and lets the leader switch to an older one. */
export default function AttainmentIntervalBar({ intervals, selected, current, onChange }: Props) {
  const label = selected?.label || selected?.interval;
  if (!label) return null;
  const range = formatPeriodRange(selected);

  return (
    <div
      style={{
        background: DASH.surface,
        border: `1px solid ${DASH.border}`,
        borderRadius: DASH.radius,
        boxShadow: DASH.shadowHairline,
        padding: '10px 18px',
      }}
    >
      <div className="flex items-end gap-4 flex-wrap">
        <div className="min-w-[220px]">
          <div className="hbr-css__text-primary-xs-semibold mb-1">Interval</div>
          <HbrSelect value={label} onHbr-change={(e) => onChange(asSingleValue(e.target.value))}>
            {intervals.map((p) => (
              <HbrOption key={String(p.label ?? p.sheet_id)} value={String(p.label ?? '')}>
                {optionText(p, current)}
              </HbrOption>
            ))}
          </HbrSelect>
        </div>
        <div style={{ paddingBottom: 6 }}>
          <span style={{ fontSize: '1rem', fontWeight: 800, color: DASH.accent }}>{label}</span>
          {range ? (
            <span style={{ fontSize: '0.8125rem', color: DASH.textDim, marginLeft: 10 }}>{range}</span>
          ) : null}
        </div>
      </div>
    </div>
  );
}
